import { createAction, props } from '@ngrx/store';
import { UserI } from 'src/app/shared/models/States/user-store.interface';

export const SET_USER = createAction('[User] Set User', props<{ user: UserI }>());

export const CLEAR_USER = createAction('[User] Clear User');

export const LOAD_USER = createAction('[User] Load User');

export const LOAD_USER_SUCCESS = createAction('[User] Load User Success', props<{ user: UserI }>());

export const LOAD_USER_FAILURE = createAction(
  '[User] Load User Failure',
  props<{ error: string }>()
);
